import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Tooltip from 'common/components/Tooltip';
import hasTouch from 'common/tools/dom/getTouchBrowser';
import noop from 'common/tools/noop';

/**
 * This HOC will mutate the "visible" property of the WrappedComponent
 * using onMouseEnter and onMouseLeave event handlers
 *
 * @param {Component} WrappedComponent A component to enhance
 * @returns {Component} a enhanced component
 */
const HIDE_DELAY = 200;

function visibleOnHover(WrappedComponent) {
  class HoverTooltip extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        visible: false
      };
      this.hideTimer = null;
    }

    componentWillUnmount() {
      this.clearHideTimer();
    }

    clearHideTimer = () => {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
    };

    showTooltip = callback => {
      this.clearHideTimer();
      this.setState({ visible: true }, () => callback(this.state.visible));
    };

    hideTooltip = () => {
      this.clearHideTimer();
      if (this.props.interactive) {
        this.hideTimer = setTimeout(() => {
          this.hideTimer = null;
          this.setState({ visible: false });
        }, HIDE_DELAY);
        return;
      }
      this.setState({ visible: false });
    };

    handleContentMouseEnter = () => {
      this.clearHideTimer();
    };

    handleContentMouseLeave = () => {
      this.hideTooltip();
    };

    toogleTooltip = callback => {
      this.setState(
        state => ({
          visible: !state.visible
        }),
        () => callback(this.state.visible)
      );
    };

    handleTargetClick = () => {
      this.toogleTooltip(this.props.onTargetClick);
    };

    handleMouseEnter = () => {
      this.showTooltip(this.props.onMouseEnter);
    };

    render() {
      let actionProps = {
        onTargetClick: this.handleTargetClick
      };

      // Desktop (no touch) devices UX
      if (!hasTouch()) {
        actionProps = {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.hideTooltip
        };

        if (this.props.interactive) {
          actionProps.onContentMouseEnter = this.handleContentMouseEnter;
          actionProps.onContentMouseLeave = this.handleContentMouseLeave;
        }
      }

      const handleContentClick = () => {
        if (this.props.onContentClick) {
          this.props.onContentClick();
        }
        this.hideTooltip();
      };

      return (
        <WrappedComponent
          {...this.props}
          {...actionProps}
          visible={this.state.visible}
          onContentClick={handleContentClick}
        />
      );
    }
  }

  HoverTooltip.propTypes = {
    interactive: PropTypes.bool,
    onMouseEnter: PropTypes.func,
    onTargetClick: PropTypes.func,
    onContentClick: PropTypes.func
  };

  HoverTooltip.defaultProps = {
    interactive: false,
    onMouseEnter: noop,
    onTargetClick: noop
  };

  return HoverTooltip;
}

export default visibleOnHover(Tooltip);
